class AuthService {
    constructor() {
        this._userId = null;
        this._photoURL = null;
        this._email = null;
    }

    setUser(user) {
        this._userId = user.uid;
        this._photoURL = user.photoURL;
        this._email = user.email;
    }

    get userId() {
        return this._userId;
    }

    get photoURL() {
        return this._photoURL;
    }

    get email() {
        return this._email;
    }

    get loggerIn() {
        return this._userId && this._email;
    }
}

export const authService = new AuthService();